<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div>
    <!-- //VNEXT-645: KLW - Adding class flex-row-top-right to correct the tool tip styling -->
    @if (this.Mode === 'design' || this.Mode === 'gridDesign') {
    <div class="flex-row-top-right">
        <div class="fill-remaining-space">
            <!-- If there are instructions, display label first, then instructions then field -->
            @if (this.HasInstructions) {
                @if (this.DisplayName) {
                <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                }</div>
                }
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
            <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true">
                @if (this.ShowLabel && !this.HasInstructions) {
                <mat-label
                    class="design-mode-field-label">
                    {{this.DisplayName}} @if (this.FormField.required) {
                    <span
                        style="color: #EF0000;">*</span>
                    }
                </mat-label>
                }
                <textarea matInput
                          placeholder="{{this.PlaceholderText}}"
                          rows="{{ this.Mode === 'gridDesign' ? '1' : this.FormField.displayRows }}"
                          [required]="this.FormField.required"
                          [attr.aria-label]="this.DisplayName"
                          disabled>{{this.DefaultValue}}</textarea>
            </mat-form-field>
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
    }
    <!-- //VNEXT-645: KLW - Adding class flex-row-top-right to correct the tool tip styling -->
    @if (this.Mode === 'preview' || this.Mode === 'instance' ) {
    <div class="flex-row-top-right">
        <div class="fill-remaining-space">
            @if ((this.ControlType === 'Reactive Forms')) {
            @if (this.FormControl !== null) {
            <!-- If there are instructions, display label first, then instructions then field -->
            @if (this.HasInstructions) {
            @if (this.DisplayName) {
            <div class="field-label">
                {{this.DisplayName}}
                @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
                }
            </div>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
            @if (FieldIsInGrid) {

            <div style="display: flex; align-items:center; width: 100%; gap: 3px;">
                <div style="flex-grow: 1;">
                    <input #gridOnlyTextArea
                           class="paragraph-in-grid"
                           matInput
                           title="{{this.DisplayName}} (Click icon to right to edit in a dialog)"
                           placeholder="{{this.PlaceholderText}}"
                           attr.aria-label="{{this.DisplayName}}"
                           [required]="this.FormField.required"
                           [readonly]="this.ReadOnly"
                           [formControl]="this.FormControl"
                           (blur)="this.handleOnBlur()"
                           (focus)="this.handleOnFocus($event)"
                           (keydown.enter)="this.handleEnterKey()" />
                </div>
                <div style="height:14pt;">
                    <mat-icon style="font-size:14pt;color:dimgrey;" title="Click to edit in a dialog" (click)="this.handleOpenGridCellEditor($event)">open_in_new</mat-icon>
                </div>
            </div>
            }
            @else {
            <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true" subscriptSizing="dynamic">
                @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                <mat-label class="design-mode-field-label">
                    {{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                    }
                </mat-label>
                }
                @if (!this.ReadOnly) {
                <textarea matInput
                          title="Double-click to edit in a dialog"
                          placeholder="{{this.PlaceholderText}}"
                          [formControl]="this.FormControl"
                          [required]="this.FormField.required"
                          [attr.aria-label]="this.DisplayName"
                          rows="{{Rows}}"
                          (blur)="this.handleOnBlur()"
                          (focus)="this.handleOnFocus($event)"></textarea>
                }
                @if (this.ReadOnly) {
                <textarea matInput
                          title="Double-click to view in a dialog"
                          readonly
                          placeholder="{{this.PlaceholderText}}"
                          [formControl]="this.FormControl"
                          [required]="this.FormField.required"
                          [attr.aria-label]="this.DisplayName"
                          rows="{{Rows}}"
                          (blur)="this.handleOnBlur()"
                          (focus)="this.handleOnFocus($event)"></textarea>
                }
            </mat-form-field>
            }
            }
            }
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
    }
</div>
